import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import { StatusLabel } from '@shared/components';
import ReferenceDetectionSummaryContent from '../components/references/ReferenceDetectionSummaryContent';
import { usePollReferenceDetection } from '../api/references.api';
import { useDocumentTitle } from '@shared/hooks';
import { TFolder, useFolder } from '../../items';
import { EDetectionPollingStatus } from '../types/shared.types';
import { TERMINOLOGY } from '@shared/i18n';

const ReferenceDetectionSummary = () => {
  const { productId, runId } = useParams();

  const { error: detectionError, data: detectionData } = usePollReferenceDetection(runId);
  const { error: folderError, data: folder } = useFolder(productId);

  const error = detectionError || folderError;
  const data = useMemo(() => {
    if (detectionData && detectionData.status === EDetectionPollingStatus.READY && folder) {
      return {
        detection: detectionData,
        folder: folder as TFolder,
      };
    }
    return null;
  }, [detectionData, folder]);

  useDocumentTitle(`${TERMINOLOGY.reference.upper} detection summary`);

  return (
    <StatusLabel
      data={data}
      loadingMessage="Loading summary..."
      error={error}
      errorMessage="Loading summary failed!"
      render={(data) => (
        <ReferenceDetectionSummaryContent
          run={data.detection.run}
          resolvedItems={data.detection.resolvedItems}
          folder={data.folder}
        />
      )}
    />
  );
};

export default ReferenceDetectionSummary;
